import {
  Home, CreditCard, ArrowDownCircle, ArrowUpCircle, Calendar, TrendingUp, AlertTriangle,
  FileText, BarChart3, ArrowLeftRight, FolderPlus, Users, Truck, Building2, Tag, Wallet,
  Settings, Ruler, Briefcase, ClipboardList, DollarSign, FolderKanban, Stethoscope,
  Scale, PartyPopper, Laptop, Camera, GraduationCap, ShoppingCart, Activity, PawPrint,
  Sparkles, Package, Wrench, Car, Box, Scissors, Handshake, Search, Mail, Bell, Receipt,
  RefreshCw
} from "lucide-react";

export interface RouteInfo {
  path: string;
  title: string;
  parent?: string;
  icon?: any;
  isNested?: boolean;
  params?: string[];
}

export interface BreadcrumbItem {
  title: string;
  path: string;
  isLast?: boolean;
}

/**
 * Complete route mapping with parent-child relationships
 * Maps URL paths to human-readable display names
 */
export const ROUTE_MAP: Record<string, RouteInfo> = {
  // Dashboard
  '/dashboard': {
    path: '/dashboard',
    title: 'Dashboard',
    icon: Home
  },

  // Transactions
  '/transactions': {
    path: '/transactions',
    title: 'Todas Transações',
    icon: CreditCard
  },
  '/transactions/expenses': {
    path: '/transactions/expenses',
    title: 'Contas a Pagar',
    parent: '/transactions',
    icon: ArrowDownCircle
  },
  '/transactions/incomes': {
    path: '/transactions/incomes',
    title: 'Contas a Receber',
    parent: '/transactions',
    icon: ArrowUpCircle
  },

  // Recurring Transactions
  '/recurring': {
    path: '/recurring',
    title: 'Transações Recorrentes',
    icon: RefreshCw
  },

  // Calendar
  '/calendar': {
    path: '/calendar',
    title: 'Calendário',
    icon: Calendar
  },

  // Cash Flow
  '/cash-flow': {
    path: '/cash-flow',
    title: 'Fluxo de Caixa',
    icon: TrendingUp
  },

  // Overdue Accounts
  '/overdue': {
    path: '/overdue',
    title: 'Inadimplentes',
    icon: AlertTriangle
  },

  // Accrual
  '/accrual': {
    path: '/accrual',
    title: 'Competência',
    icon: FileText
  },

  // Reports
  '/reports': {
    path: '/reports',
    title: 'Relatórios',
    icon: BarChart3
  },

  // Reconciliation
  '/reconciliation': {
    path: '/reconciliation',
    title: 'Conciliação Bancária',
    icon: ArrowLeftRight
  },

  // Cadastros (Parent section)
  '/cadastros': {
    path: '/cadastros',
    title: 'Cadastros',
    icon: FolderPlus
  },

  // Cadastros Sub-items
  '/cadastros/clients': {
    path: '/cadastros/clients',
    title: 'Clientes',
    parent: '/cadastros',
    icon: Users
  },
  '/cadastros/suppliers': {
    path: '/cadastros/suppliers',
    title: 'Fornecedores',
    parent: '/cadastros',
    icon: Truck
  },
  '/cadastros/cost-centers': {
    path: '/cadastros/cost-centers',
    title: 'Centros de Custo',
    parent: '/cadastros',
    icon: Building2
  },
  '/cadastros/categories': {
    path: '/cadastros/categories',
    title: 'Categorias',
    parent: '/cadastros',
    icon: Tag
  },
  '/cadastros/payment-accounts': {
    path: '/cadastros/payment-accounts',
    title: 'Contas de Pagamento',
    parent: '/cadastros',
    icon: Wallet
  },

  // Services (Parent section)
  '/services': {
    path: '/services',
    title: 'Serviços',
    icon: Handshake
  },

  // Services Sub-items
  '/services/budgets': {
    path: '/services/budgets',
    title: 'Orçamentos',
    parent: '/services',
    icon: FileText
  },
  '/services/budgets/new': {
    path: '/services/budgets/new',
    title: 'Novo Orçamento',
    parent: '/services/budgets',
    icon: FileText,
    params: ['id']
  },
  '/services/budgets/analytics': {
    path: '/services/budgets/analytics',
    title: 'Análises de Orçamentos',
    parent: '/services/budgets',
    icon: BarChart3
  },
  '/services/budgets/reports': {
    path: '/services/budgets/reports',
    title: 'Relatórios de Orçamentos',
    parent: '/services/budgets',
    icon: FileText
  },
  '/services/budgets/conversion': {
    path: '/services/budgets/conversion',
    title: 'Taxas de Conversão',
    parent: '/services/budgets',
    icon: TrendingUp
  },
  '/services/sales': {
    path: '/services/sales',
    title: 'Vendas de serviços',
    parent: '/services',
    icon: ShoppingCart
  },
  '/services/sales/new': {
    path: '/services/sales/new',
    title: 'Nova venda',
    parent: '/services/sales',
    icon: ShoppingCart
  },
  '/services/contracts': {
    path: '/services/contracts',
    title: 'Contratos',
    parent: '/services',
    icon: FileText
  },
  '/services/work-orders': {
    path: '/services/work-orders',
    title: 'Ordens de serviço',
    parent: '/services',
    icon: ClipboardList
  },
  '/services/installments': {
    path: '/services/installments',
    title: 'Parcelas a receber',
    parent: '/services',
    icon: ArrowUpCircle
  },
  '/services/invoices': {
    path: '/services/invoices',
    title: 'Notas fiscais de serviço',
    parent: '/services',
    icon: Receipt
  },
  '/services/serasa': {
    path: '/services/serasa',
    title: 'Consulta Serasa',
    parent: '/services',
    icon: Search
  },
  '/services/due-reminders': {
    path: '/services/due-reminders',
    title: 'Lembretes de vencimento',
    parent: '/services',
    icon: Bell
  },
  '/services/cadastros/clients': {
    path: '/services/cadastros/clients',
    title: 'Clientes',
    parent: '/services',
    icon: Users
  },
  '/services/cadastros/services': {
    path: '/services/cadastros/services',
    title: 'Serviços',
    parent: '/services',
    icon: ClipboardList
  },
  '/services/cadastros/carriers': {
    path: '/services/cadastros/carriers',
    title: 'Transportadoras',
    parent: '/services',
    icon: Truck
  },
  '/services/settings/invoices': {
    path: '/services/settings/invoices',
    title: 'Configurar notas fiscais',
    parent: '/services',
    icon: Receipt
  },
  '/services/settings/email-template': {
    path: '/services/settings/email-template',
    title: 'Modelo de e-mail de venda',
    parent: '/services',
    icon: Mail
  },
  '/services/settings/invoice-series': {
    path: '/services/settings/invoice-series',
    title: 'Séries de notas fiscais',
    parent: '/services',
    icon: FileText
  },

  // Settings
  '/settings': {
    path: '/settings',
    title: 'Configurações',
    icon: Settings
  },

  // Architects and Engineers
  '/architects-engineers/dashboard': {
    path: '/architects-engineers/dashboard',
    title: 'Dashboard de Projetos',
    icon: Ruler
  },
  '/architects-engineers/projects': {
    path: '/architects-engineers/projects',
    title: 'Todos os Projetos',
    icon: Briefcase
  },
  '/architects-engineers/add-expense': {
    path: '/architects-engineers/add-expense',
    title: 'Lançar Custo no Projeto',
    icon: TrendingUp
  },
  '/architects-engineers/stages': {
    path: '/architects-engineers/stages',
    title: 'Etapas e Cronograma',
    icon: ClipboardList
  },
  '/architects-engineers/feasibility': {
    path: '/architects-engineers/feasibility',
    title: 'Relatório de Viabilidade',
    icon: DollarSign
  },

  // Consulting
  '/consulting/dashboard': {
    path: '/consulting/dashboard',
    title: 'Dashboard de Consultorias',
    icon: Briefcase
  },
  '/consulting/projects': {
    path: '/consulting/projects',
    title: 'Todos os Projetos',
    icon: FolderKanban
  },
  '/consulting/add-expense': {
    path: '/consulting/add-expense',
    title: 'Lançar Custo no Projeto',
    icon: TrendingUp
  },
  '/consulting/contracts': {
    path: '/consulting/contracts',
    title: 'Contratos e Recorrências',
    icon: FileText
  },
  '/consulting/profitability': {
    path: '/consulting/profitability',
    title: 'Relatório de Rentabilidade',
    icon: DollarSign
  },

  // Health Clinics
  '/health-clinics/dashboard': {
    path: '/health-clinics/dashboard',
    title: 'Dashboard Clínico',
    icon: Stethoscope
  },
  '/health-clinics/procedures': {
    path: '/health-clinics/procedures',
    title: 'Procedimentos',
    icon: ClipboardList
  },
  '/health-clinics/revenue': {
    path: '/health-clinics/revenue',
    title: 'Relatório de Receitas',
    icon: DollarSign
  },

  // Law Firms
  '/law-firms/dashboard': {
    path: '/law-firms/dashboard',
    title: 'Dashboard Jurídico',
    icon: Scale
  },
  '/law-firms/cases': {
    path: '/law-firms/cases',
    title: 'Processos',
    icon: FileText
  },
  '/law-firms/fees': {
    path: '/law-firms/fees',
    title: 'Honorários',
    icon: DollarSign
  },
  '/law-firms/performance': {
    path: '/law-firms/performance',
    title: 'Relatório de Performance',
    icon: TrendingUp
  },

  // Events
  '/events/dashboard': {
    path: '/events/dashboard',
    title: 'Dashboard de Eventos',
    icon: PartyPopper
  },
  '/events/list': {
    path: '/events/list',
    title: 'Todos os Eventos',
    icon: Calendar
  },
  '/events/add-expense': {
    path: '/events/add-expense',
    title: 'Lançar Custo no Evento',
    icon: TrendingUp
  },
  '/events/report': {
    path: '/events/report',
    title: 'Relatório de Eventos',
    icon: DollarSign
  },

  // IT Companies
  '/it-companies/dashboard': {
    path: '/it-companies/dashboard',
    title: 'Dashboard de TI',
    icon: Laptop
  },
  '/it-companies/projects': {
    path: '/it-companies/projects',
    title: 'Projetos',
    icon: FolderKanban
  },
  '/it-companies/contracts': {
    path: '/it-companies/contracts',
    title: 'Contratos SLA',
    icon: FileText
  },
  '/it-companies/tickets': {
    path: '/it-companies/tickets',
    title: 'Tickets',
    icon: ClipboardList
  },
  '/it-companies/sla-report': {
    path: '/it-companies/sla-report',
    title: 'Relatório de SLA',
    icon: TrendingUp
  },

  // Photographers
  '/photographers/dashboard': {
    path: '/photographers/dashboard',
    title: 'Dashboard de Projetos',
    icon: Camera
  },
  '/photographers/projects': {
    path: '/photographers/projects',
    title: 'Todos os Projetos',
    icon: Briefcase
  },
  '/photographers/add-expense': {
    path: '/photographers/add-expense',
    title: 'Lançar Custo no Projeto',
    icon: TrendingUp
  },
  '/photographers/events': {
    path: '/photographers/events',
    title: 'Eventos',
    icon: Calendar
  },
  '/photographers/profitability': {
    path: '/photographers/profitability',
    title: 'Relatório de Lucratividade',
    icon: DollarSign
  },

  // Education
  '/education/dashboard': {
    path: '/education/dashboard',
    title: 'Dashboard Educacional',
    icon: GraduationCap
  },
  '/education/courses': {
    path: '/education/courses',
    title: 'Cursos',
    icon: FolderKanban
  },
  '/education/sales': {
    path: '/education/sales',
    title: 'Vendas',
    icon: ShoppingCart
  },
  '/education/revenue': {
    path: '/education/revenue',
    title: 'Relatório de Receitas',
    icon: DollarSign
  },

  // Pilates/Yoga
  '/pilates-yoga/dashboard': {
    path: '/pilates-yoga/dashboard',
    title: 'Dashboard do Estúdio',
    icon: Activity
  },
  '/pilates-yoga/subscriptions': {
    path: '/pilates-yoga/subscriptions',
    title: 'Mensalidades',
    icon: CreditCard
  },
  '/pilates-yoga/classes': {
    path: '/pilates-yoga/classes',
    title: 'Aulas',
    icon: Calendar
  },
  '/pilates-yoga/financial': {
    path: '/pilates-yoga/financial',
    title: 'Relatório Financeiro',
    icon: DollarSign
  },

  // Veterinary
  '/veterinary/dashboard': {
    path: '/veterinary/dashboard',
    title: 'Dashboard Veterinário',
    icon: PawPrint
  },
  '/veterinary/consultations': {
    path: '/veterinary/consultations',
    title: 'Consultas',
    icon: Calendar
  },
  '/veterinary/procedures': {
    path: '/veterinary/procedures',
    title: 'Procedimentos',
    icon: ClipboardList
  },
  '/veterinary/revenue': {
    path: '/veterinary/revenue',
    title: 'Relatório de Receitas',
    icon: DollarSign
  },

  // Beauty Clinics
  '/beauty-clinics/dashboard': {
    path: '/beauty-clinics/dashboard',
    title: 'Dashboard de Estética',
    icon: Sparkles
  },
  '/beauty-clinics/procedures': {
    path: '/beauty-clinics/procedures',
    title: 'Procedimentos',
    icon: ClipboardList
  },
  '/beauty-clinics/packages': {
    path: '/beauty-clinics/packages',
    title: 'Pacotes',
    icon: Package
  },
  '/beauty-clinics/revenue': {
    path: '/beauty-clinics/revenue',
    title: 'Relatório de Receitas',
    icon: DollarSign
  },

  // Auto Repair
  '/auto-repair/dashboard': {
    path: '/auto-repair/dashboard',
    title: 'Dashboard da Oficina',
    icon: Wrench
  },
  '/auto-repair/orders': {
    path: '/auto-repair/orders',
    title: 'Ordens de Serviço',
    icon: ClipboardList
  },
  '/auto-repair/vehicles': {
    path: '/auto-repair/vehicles',
    title: 'Veículos',
    icon: Car
  },
  '/auto-repair/inventory': {
    path: '/auto-repair/inventory',
    title: 'Estoque',
    icon: Box
  },
  '/auto-repair/services-report': {
    path: '/auto-repair/services-report',
    title: 'Relatório de Serviços',
    icon: DollarSign
  },

  // Beauty Salons
  '/beauty-salons/dashboard': {
    path: '/beauty-salons/dashboard',
    title: 'Dashboard do Salão',
    icon: Scissors
  },
  '/beauty-salons/services': {
    path: '/beauty-salons/services',
    title: 'Serviços',
    icon: ClipboardList
  },
  '/beauty-salons/revenue': {
    path: '/beauty-salons/revenue',
    title: 'Relatório de Receitas',
    icon: DollarSign
  }
};

/**
 * Get route info for a specific path
 * @param path - The URL path to lookup
 * @returns RouteInfo object or undefined if not found
 */
export function getRouteInfo(path: string): RouteInfo | undefined {
  // First try exact match
  if (ROUTE_MAP[path]) {
    return ROUTE_MAP[path];
  }

  // Try to find the closest parent match for nested routes
  const sortedKeys = Object.keys(ROUTE_MAP)
    .sort((a, b) => b.length - a.length)
    .filter(key => path.startsWith(key));

  return sortedKeys.length > 0 ? ROUTE_MAP[sortedKeys[0]] : undefined;
}

/**
 * Get the display name for the current route
 * @param path - The current URL path
 * @returns Human-readable route title or fallback
 */
export function getRouteDisplayName(path: string): string {
  const routeInfo = getRouteInfo(path);
  return routeInfo?.title || 'Página';
}

/**
 * Generate breadcrumb items for a given path
 * @param path - The current URL path
 * @returns Array of breadcrumb items
 */
export function generateBreadcrumbs(path: string): BreadcrumbItem[] {
  const breadcrumbs: BreadcrumbItem[] = [];
  const segments = path.split('/').filter(Boolean);

  if (segments.length === 0) {
    return breadcrumbs;
  }

  // Build breadcrumb trail
  let currentPath = '';
  segments.forEach((segment, index) => {
    currentPath += `/${segment}`;
    const routeInfo = getRouteInfo(currentPath);

    if (routeInfo) {
      breadcrumbs.push({
        title: routeInfo.title,
        path: currentPath,
        isLast: index === segments.length - 1
      });
    }
  });

  // If no breadcrumbs found, add a default one
  if (breadcrumbs.length === 0) {
    breadcrumbs.push({
      title: 'Dashboard',
      path: '/dashboard',
      isLast: true
    });
  }

  return breadcrumbs;
}

/**
 * Check if a route is currently active
 * @param currentPath - The current URL path
 * @param routePath - The route path to check against
 * @returns Boolean indicating if route is active
 */
export function isRouteActive(currentPath: string, routePath: string): boolean {
  // Exact match
  if (currentPath === routePath) {
    return true;
  }

  // Parent route match (for nested routes)
  if (currentPath.startsWith(routePath + '/')) {
    return true;
  }

  return false;
}

/**
 * Get all child routes for a parent path
 * @param parentPath - The parent route path
 * @returns Array of child route info
 */
export function getChildRoutes(parentPath: string): RouteInfo[] {
  return Object.values(ROUTE_MAP)
    .filter(route => route.parent === parentPath)
    .sort((a, b) => a.title.localeCompare(b.title));
}

/**
 * Get parent route for a given path
 * @param path - The URL path
 * @returns Parent route info or undefined
 */
export function getParentRoute(path: string): RouteInfo | undefined {
  const routeInfo = getRouteInfo(path);
  if (!routeInfo?.parent) {
    return undefined;
  }

  return getRouteInfo(routeInfo.parent);
}

/**
 * Search for routes by title
 * @param searchTerm - The search term
 * @returns Array of matching routes
 */
export function searchRoutes(searchTerm: string): RouteInfo[] {
  const lowerSearchTerm = searchTerm.toLowerCase();
  return Object.values(ROUTE_MAP)
    .filter(route =>
      route.title.toLowerCase().includes(lowerSearchTerm)
    )
    .sort((a, b) => a.title.localeCompare(b.title));
}